/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BulkInvestmentProposalResponse model module.
 * @module model/BulkInvestmentProposalResponse
 * @version 1.0.0
 */
class BulkInvestmentProposalResponse {
    /**
     * Constructs a new <code>BulkInvestmentProposalResponse</code>.
     * @alias module:model/BulkInvestmentProposalResponse
     */
    constructor() { 
        
        BulkInvestmentProposalResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BulkInvestmentProposalResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BulkInvestmentProposalResponse} obj Optional instance to populate.
     * @return {module:model/BulkInvestmentProposalResponse} The populated <code>BulkInvestmentProposalResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BulkInvestmentProposalResponse();

            if (data.hasOwnProperty('accepted_count')) {
                obj['accepted_count'] = ApiClient.convertToType(data['accepted_count'], 'Number');
            }
            if (data.hasOwnProperty('skipped_count')) {
                obj['skipped_count'] = ApiClient.convertToType(data['skipped_count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BulkInvestmentProposalResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BulkInvestmentProposalResponse</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 作成した提案数
 * @member {Number} accepted_count
 */
BulkInvestmentProposalResponse.prototype['accepted_count'] = undefined;

/**
 * 対象外にした数（本日すでに同一エージェントからオファー済み、送信待ちの提案が既にある、退会済みなど）
 * @member {Number} skipped_count
 */
BulkInvestmentProposalResponse.prototype['skipped_count'] = undefined;






export default BulkInvestmentProposalResponse;

